/**
 * User: daletan
 * Date: 12/22/14
 * Time: 7:30 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var Backbone = require('dibs-backbone');
var headerStr = 'YOUR RECENT HISTORY';

module.exports = Backbone.BaseView.extend({
    className: 'recent-history-title',
    render: function() {
        this.$el.html(headerStr);
        return this;
    },
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/recentHistory/RecentHistoryTitleView.js
// module id = 808
// module chunks = 4 5 6 7 8